import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Home from "./components/Home";

import "./index.css";
import Layout from "./components/Layout";
import ComingSoon from "./components/ComingSoon";
import Services from "./components/Services";
import Contact from "./components/Contact";

const router = createBrowserRouter([
  {
    path: "/",
    children: [
      {
        path: "coming-soon",
        element: <ComingSoon />,
      },
      {
        path: "/",
        element: <Layout />,
        children: [
          {
            path: "/",
            element: <Home />,
          },
          {
            path: "services",
            element: <Services />,
          },
          {
            path: "contact",
            element: <Contact />,
          },
        ],
      },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
